import './CodeViewToggle.css'

// Drill-down (segmented): a chevron, matching the row drill arrows.
const IconSegmented = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 6 15 12 9 18" />
  </svg>
)

// Collapsed (show all): progressively indented lines = a flattened tree.
const IconCollapsed = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="9" y1="12" x2="20" y2="12" />
    <line x1="14" y1="18" x2="20" y2="18" />
  </svg>
)

// Two-option control to switch the nav between drill-down (segmented) and
// collapsed (all-descendants) browsing. Lives at the right of the location bar.
function CodeViewToggle({ mode, onChange }) {
  return (
    <div className="code-viewtoggle" role="group" aria-label="Nav view">
      <button
        type="button"
        className={mode === 'segmented' ? 'is-active' : ''}
        title="Drill-down: one level at a time"
        aria-label="Drill-down view"
        aria-pressed={mode === 'segmented'}
        onClick={() => onChange('segmented')}
      >
        <IconSegmented />
      </button>
      <button
        type="button"
        className={mode === 'collapsed' ? 'is-active' : ''}
        title="Collapsed: show all subsections"
        aria-label="Collapsed view"
        aria-pressed={mode === 'collapsed'}
        onClick={() => onChange('collapsed')}
      >
        <IconCollapsed />
      </button>
    </div>
  )
}

export default CodeViewToggle
